export const environment = {
  apiUrl: '',
  production: false,
  log: true,
  maxCacheAge: 900000,
  httpRetryNumber: 1
};
